/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TherapyRecommendationQuestionType_therapy_recommendation_question_type_enum {
    TEXT = 'text',
    RANGE = 'range',
}
